import * as actions from "../actions";

const initialState = {
  role: null,
  other: null,
  firstname: null,
  middlename: null,
  lastname: null,
  company: null,
  contactNumber: null,
  emailAddress: null,
  repeatEmail: null,
  postalAddress: null,
};

export default (state = initialState, action) => {

  switch (action.type) {
    case actions.STORE_CONTACT_DATA:
      return {
        ...state,
        ...action.payload
      }
    case actions.RESET_DATA:
      return {
        ...initialState
      }
    default:
      return state
  }
}
